import Text from 'antd/es/typography/Text';

export default function(props) {
	return (
		<Text {...props} style={{ fontFamily: 'Chinese', }}>
      {props.children}
    </Text>
	)
}